module.exports = __webpack_public_path__ + "img/big_text.eb59ddc8.png";